export default "__VITE_ASSET__DBot6jV4__"